var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand__Action Type=Expand, State=Enabled, Size=24",
    className: "expand__Action expand__Type=Expand, expand__State=Enabled, expand__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand__Vector (Stroke)",
    fill: "currentColor",
    d: "m10.52 13.427.475.474-5.77 5.756H9.06l.07.004a.671.671 0 0 1 0 1.335L9.06 21H3.603c-.37 0-.671-.3-.671-.671V15.07a.671.671 0 0 1 1.343 0v3.639l5.771-5.759.474.476Zm-.474-.476a.672.672 0 0 1 .949.95l-.949-.95ZM21.068 8.93a.672.672 0 0 1-1.343 0V5.29l-5.771 5.76-.052.045a.67.67 0 0 1-.897-.996l5.768-5.755H14.94a.672.672 0 0 1 0-1.343h5.457c.37 0 .671.3.671.671V8.93Z",
    className: "expand__Vector expand__(Stroke)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.24821793e335d382704fac985cd2c201.svg";
export { ForwardRef as ReactComponent };